import { Carousel } from 'antd'
import styled from 'styled-components'

import { useMarketingCTAs } from 'features/auth/hooks/use-marketing-ct-as'

const CarouselContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #28364f;
`

const SquareCarousel = styled(Carousel)`
  width: min(100vh, 100vw);
  height: min(100vh, 100vw);

  .slick-slide {
    height: min(100vh, 100vw) !important;
  }

  .slick-list {
    height: min(100vh, 100vw) !important;
  }

  .slick-track {
    height: min(100vh, 100vw) !important;
  }
`

const CarouselSlide = ({
  img,
  link,
}: {
  img: string
  link: string | null
}): JSX.Element => {
  const squareSize = 'min(100vh, 100vw)'

  return (
    <div
      style={{
        width: squareSize,
        height: squareSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#28364f',
      }}
    >
      {link ? (
        <a href={link} target="_blank" rel="noopener noreferrer">
          <img
            src={img}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            alt="Marketing content"
          />
        </a>
      ) : (
        <img
          src={img}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
          alt="Marketing content"
        />
      )}
    </div>
  )
}

export const MarketingCTASigninPage = (): JSX.Element => {
  const { data: ctas, isLoading, error } = useMarketingCTAs()
  const hasMultipleCTAs = ctas && ctas.length > 1

  if (error) {
    /* intentionally empty */
  }

  return (
    <CarouselContainer>
      <SquareCarousel
        arrows={hasMultipleCTAs}
        draggable={hasMultipleCTAs}
        dots={hasMultipleCTAs}
        infinite
        autoplay={hasMultipleCTAs}
        autoplaySpeed={5000}
      >
        {!isLoading &&
          ctas &&
          ctas.map((cta, index) => (
            <CarouselSlide key={index} img={cta.image_url} link={cta.link} />
          ))}
      </SquareCarousel>
    </CarouselContainer>
  )
}
